<template>
  <button :class="['gfr-button', customClass]" @click="handleClick">
    <slot />
  </button>
</template>
<script lang="ts" setup>
import { UnknownProp } from '~/components/gfr/utils/base'
import './styles/index.scss'
const props = defineProps({
  class: {
    type: UnknownProp
  }
})
const emit = defineEmits(['click'])
const customClass = computed(() => {
  return props.class
})
function handleClick() {
  emit('click')
}
</script>
